import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinner-form-control',
  templateUrl: './spinner-form-control.component.html',
  styleUrls: ['./spinner-form-control.component.scss'],
})
export class SpinnerFormControlComponent {
  @Input() label = '';
  @Input() isLoading = false;
  @Input() diameter = 20;

  get useCustomSpacing(): boolean {
    return !!this.label;
  }
}
